import { Button, Modal, Card } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Images from "../../Images";
import { DUImage } from "../../pages/types/DUImage";

type ProductImage = { image: DUImage, selected: boolean };
const ImageSelector = (props: any) => {
    const handleSave = props.handleSelected;
    const [selected, setSelected] = useState<ProductImage>();
    const [saved, setSaved] = useState<ProductImage>();
    const [show, setShow] = useState(false);
    const [useImage, setUseImage] = useState<string>();

    const handleClose = () => {
        setShow(false);
    };

    const handleShow = () => setShow(true);

    const onSelected = (item: ProductImage) => {
        setSelected(item);
    };

    const onSave = () => {
        setSaved({ image: props.selected, selected: true });
        handleSave && handleSave(selected?.image);
        handleClose();
    };

    const getOriginal = () => {
        setUseImage(saved?.image?.original);
    }

    useEffect(() => {
        setSaved({ image: props.selected, selected: true });
        setUseImage(props.selected?.thumbnail || '');
        setSelected({ image: props.selected, selected: true });
    }, [props.selected]);

    return (
        <>
            <Card style={{ maxWidth: '24rem' }}>
                {saved?.image ? <div className="mt-3 mx-3"><Card.Img onError={getOriginal} variant="top" src={useImage} alt="" style={{ margin: "0 auto", display: "block", width: "100%" }} /></div> : null}

                <Card.Body>
                    <Button variant="secondary" onClick={handleShow}>
                        {saved?.image ? 'Edit' : 'Add'} Image <FontAwesomeIcon icon="plus" />
                    </Button>
                </Card.Body>
            </Card>
            <Modal show={show} onHide={handleClose} size="xl" scrollable={true}>
                <Modal.Header closeButton>
                    <Modal.Title>Image Selector</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Images selectMode={true} selectedItems={[selected]} handleSelected={onSelected} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>

                    <Button variant="primary" onClick={onSave}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ImageSelector;